module.exports = __webpack_public_path__ + "static/MapMobile-b9c56ede439d9b895c7c9dedd5085fd4.svg";